(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const initArticleDetail = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const content = root.querySelector('[data-article-content]');
      const tocWrappers = Array.from(root.querySelectorAll('[data-article-toc]'));
      const copyButton = root.querySelector('[data-copy-link]');
      if (copyButton) {
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(copyButton.dataset.copyLink || window.location.href);
            copyButton.textContent = 'Copied';
            window.setTimeout(() => {
              copyButton.textContent = 'Copy link';
            }, 1500);
          } catch (error) {
            copyButton.textContent = 'Copy failed';
          }
        });
      }

      if (!content || tocWrappers.length === 0) return;

      let headings = Array.from(content.querySelectorAll('h2'));
      if (!headings.length) {
        headings = Array.from(content.querySelectorAll('h3'));
      }
      if (!headings.length) return;

      const slugify = (value) =>
        (value || '')
          .toLowerCase()
          .trim()
          .replace(/<[^>]*>/g, '')
          .replace(/[^a-z0-9\u4e00-\u9fa5\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');

      const usedIds = new Set();
      headings.forEach((heading, index) => {
        let baseId = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
        let finalId = baseId;
        let duplicate = 2;
        while (usedIds.has(finalId) || (document.getElementById(finalId) && document.getElementById(finalId) !== heading)) {
          finalId = `${baseId}-${duplicate}`;
          duplicate += 1;
        }
        usedIds.add(finalId);
        heading.id = finalId;
      });

      tocWrappers.forEach((wrapper) => {
        const list = wrapper.querySelector('[data-article-toc-list]');
        if (!list) return;
        list.innerHTML = headings.map((heading) => `<li><a href="#${heading.id}">${heading.textContent.trim()}</a></li>`).join('');
      });

      const links = Array.from(root.querySelectorAll('[data-article-toc-list] a'));
      if (!links.length) return;

      const setActive = (id) => {
        links.forEach((link) => {
          const active = link.getAttribute('href') === `#${id}`;
          link.classList.toggle('is-active', active);
          link.classList.toggle('active', active);
        });
      };

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const id = link.getAttribute('href').replace('#', '');
          const target = document.getElementById(id);
          if (target) {
            setActive(id);
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      const getOffsets = () =>
        headings.map((heading) => ({
          id: heading.id,
          top: heading.getBoundingClientRect().top + window.scrollY
        }));

      let offsets = getOffsets();
      let ticking = false;

      const update = () => {
        const currentY = window.scrollY + 140;
        let currentId = headings[0].id;
        offsets.forEach((item) => {
          if (currentY >= item.top) currentId = item.id;
        });
        setActive(currentId);
        ticking = false;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

            if (visible.length) {
              setActive(visible[0].target.id);
            } else {
              onScroll();
            }
          },
          {
            rootMargin: '-20% 0px -65% 0px',
            threshold: [0, 1]
          }
        );

        headings.forEach((heading) => observer.observe(heading));
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        offsets = getOffsets();
        onScroll();
      });

      setActive(headings[0].id);
      onScroll();
    };

    const initRoots = (scope) => {
      if (!scope || !scope.querySelectorAll) return;
      scope.querySelectorAll('[data-article-detail]').forEach(initArticleDetail);
    };

    initRoots(document);
    document.addEventListener('shopify:section:load', (event) => initRoots(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    function setupCollection(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const drawer = root.querySelector('[data-filter-drawer]');
      const sidebar = root.querySelector('#FacetFiltersContainer');
      const drawerForm = drawer ? drawer.querySelector('form') : null;
      const openButtons = root.querySelectorAll('[data-filter-open]');
      const closeButtons = root.querySelectorAll('[data-filter-close]');
      const submitButtons = root.querySelectorAll('[data-filter-submit]');
      const toggleDrawer = (open) => {
        if (!drawer) return;
        drawer.hidden = !open;
        document.body.classList.toggle('mobile-menu-open', open);
      };
      openButtons.forEach((button) =>
        button.addEventListener('click', () => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            if (sidebar) sidebar.classList.toggle('hidden');
            return;
          }
          toggleDrawer(true);
        })
      );
      closeButtons.forEach((button) => button.addEventListener('click', () => toggleDrawer(false)));
      submitButtons.forEach((button) =>
        button.addEventListener('click', () => {
          if (drawerForm) drawerForm.requestSubmit();
        })
      );
      root.querySelectorAll('.collection-heybike__card').forEach((card) => {
        if (card.dataset.collectionCardReady === 'true') return;
        card.dataset.collectionCardReady = 'true';

        const swatches = Array.from(card.querySelectorAll('[data-card-swatch]'));
        const images = Array.from(card.querySelectorAll('[data-card-image]'));
        if (!swatches.length || !images.length) return;

        const setActive = (colorKey) => {
          swatches.forEach((item) => {
            const isActive = (item.dataset.colorKey || '') === colorKey;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            const parent = item.closest('li');
            if (parent) parent.classList.toggle('active', isActive);
          });

          let hasMatch = false;
          images.forEach((item) => {
            const isActive = (item.dataset.colorKey || '') === colorKey;
            if (isActive) hasMatch = true;
            item.classList.toggle('is-active', isActive);
            item.classList.toggle('active', isActive);
          });

          if (!hasMatch && images[0]) {
            images.forEach((item, index) => {
              const isFallback = index === 0;
              item.classList.toggle('is-active', isFallback);
              item.classList.toggle('active', isFallback);
            });
          }
        };

        swatches.forEach((swatch) => {
          const colorKey = swatch.dataset.colorKey || '';
          swatch.addEventListener('click', (event) => {
            event.preventDefault();
            setActive(colorKey);
          });
          swatch.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            setActive(colorKey);
          });
        });

        setActive(swatches[0].dataset.colorKey || '');
      });
    }
    const initSections = (root) => {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('[data-collection-heybike]').forEach(setupCollection);
    };
    initSections(document);
    document.addEventListener('shopify:section:load', (event) => initSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-search-panel]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const input = root.querySelector('.search-side-panel__input');
    const results = root.querySelector('[data-search-panel-results]');
    const pagesWrap = root.querySelector('[data-search-panel-pages-wrap]');
    const pagesList = root.querySelector('[data-search-panel-pages]');
    const productsList = root.querySelector('[data-search-panel-products]');
    const emptyState = root.querySelector('[data-search-panel-empty]');
    const openers = document.querySelectorAll('[data-open-search-panel]');
    const closers = root.querySelectorAll('[data-search-panel-close]');
    let controller;
    let timer;

    const escapeHtml = (value) =>
      String(value || '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');

    const resetResults = () => {
      results.hidden = true;
      pagesWrap.hidden = true;
      pagesList.innerHTML = '';
      productsList.innerHTML = '';
      emptyState.hidden = true;
      emptyState.textContent = '';
    };

    const renderResults = (payload, term) => {
      const pages = payload?.resources?.results?.pages || [];
      const products = payload?.resources?.results?.products || [];

      results.hidden = false;

      if (pages.length) {
        pagesWrap.hidden = false;
        pagesList.innerHTML = pages
          .slice(0, 4)
          .map((page) => `<a class="search-side-panel__page-link" href="${page.url}">${escapeHtml(page.title)}</a>`)
          .join('');
      } else {
        pagesWrap.hidden = true;
        pagesList.innerHTML = '';
      }

      if (products.length) {
        productsList.innerHTML = products
          .slice(0, 6)
          .map((product) => {
            const image = product.featured_image?.url || '';
            const title = escapeHtml(product.title);
            return `
              <a class="search-side-panel__product" href="${product.url}">
                <div class="search-side-panel__product-media">
                  ${image ? `<img class="search-side-panel__product-image" src="${image}&width=360" alt="${title}" loading="lazy">` : ''}
                </div>
                <div class="search-side-panel__product-title">${title}</div>
              </a>
            `;
          })
          .join('');
        emptyState.hidden = true;
        emptyState.textContent = '';
      } else {
        productsList.innerHTML = '';
        emptyState.hidden = false;
        emptyState.textContent = `No results found for "${term}"`;
      }
    };

    const fetchResults = (term) => {
      if (controller) controller.abort();
      controller = new AbortController();
      const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,page&resources[limit]=6&resources[options][unavailable_products]=last`;
      fetch(url, { signal: controller.signal })
        .then((response) => response.json())
        .then((payload) => renderResults(payload, term))
        .catch((error) => {
          if (error.name !== 'AbortError') {
            resetResults();
          }
        });
    };

    const open = () => {
      root.hidden = false;
      requestAnimationFrame(() => {
        root.classList.add('is-open');
        input?.focus();
      });
    };

    const close = () => {
      root.classList.remove('is-open');
      setTimeout(() => {
        if (!root.classList.contains('is-open')) {
          root.hidden = true;
        }
      }, 320);
    };

    openers.forEach((button) => {
      button.addEventListener('click', open);
    });

    closers.forEach((button) => {
      button.addEventListener('click', close);
    });

    input?.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 1) {
        resetResults();
        return;
      }
      timer = setTimeout(() => fetchResults(term), 180);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-blog-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBlogFeed = (scope) => {
      scope.querySelectorAll('.home-blog-feed').forEach((section) => {
        if (section.dataset.blogReady === 'true') return;
        section.dataset.blogReady = 'true';

        const viewport = section.querySelector('[data-blog-viewport]');
        const prev = section.querySelector('[data-blog-nav="prev"]');
        const next = section.querySelector('[data-blog-nav="next"]');
        if (!viewport || !prev || !next) return;

        const getStep = () => {
          const card = viewport.querySelector('.home-blog-feed__card');
          if (!card) return viewport.clientWidth;
          const styles = window.getComputedStyle(viewport.querySelector('.home-blog-feed__track'));
          const gap = parseFloat(styles.columnGap || styles.gap || 0);
          return card.getBoundingClientRect().width + gap;
        };

        prev.addEventListener('click', () => {
          viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
          viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      });
    };

    initBlogFeed(document);
    document.addEventListener('shopify:section:load', (event) => initBlogFeed(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-dynamic-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function setupDynamicCards(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.ready === 'true') return;
      sectionRoot.dataset.ready = 'true';
      const cards = Array.from(sectionRoot.querySelectorAll('[data-dynamic-card]'));
      const activate = (card) => {
        cards.forEach((item) => item.classList.toggle('is-active', item === card));
      };
      cards.forEach((card) => {
        card.addEventListener('mouseenter', () => activate(card));
        card.addEventListener('focus', () => activate(card));
      });
    }
    const initDynamicCardSections = (root) => {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('[data-home-dynamic-cards]').forEach(setupDynamicCards);
    };
    initDynamicCardSections(document);
    document.addEventListener('shopify:section:load', (event) => initDynamicCardSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFeaturedCards = (scope) => {
      scope.querySelectorAll('.home-featured-products__card').forEach((card) => {
        if (card.dataset.featuredProductsReady === 'true') return;
        card.dataset.featuredProductsReady = 'true';

        const triggers = Array.from(card.querySelectorAll('[data-swatch-trigger]'));
        const images = Array.from(card.querySelectorAll('[data-swatch-image]'));
        if (!triggers.length || !images.length) return;

        const setActive = (value) => {
          triggers.forEach((trigger) => {
            const isActive = trigger.dataset.swatchTrigger === value;
            trigger.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          images.forEach((image) => {
            image.classList.toggle('is-active', image.dataset.swatchImage === value);
          });
        };

        triggers.forEach((trigger) => {
          const value = trigger.dataset.swatchTrigger;
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            setActive(value);
          });
          trigger.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            setActive(value);
          });
        });

        setActive(triggers[0].dataset.swatchTrigger);
      });
    };

    initFeaturedCards(document);
    document.addEventListener('shopify:section:load', (event) => initFeaturedCards(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-heybike-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupHero = (root) => {
      const track = root.querySelector('[data-hero-track]');
      const tabs = Array.from(root.querySelectorAll('[data-hero-tab]'));
      const progress = root.querySelector('[data-hero-progress]');
      const interval = Number(root.dataset.interval || 5000);
      if (!track) return;

      let index = 0;
      let timerId;

      const startProgress = () => {
        if (!progress) return;
        progress.style.animation = 'none';
        progress.offsetHeight;
        progress.style.animation = `home-hero-banner-progress ${interval}ms linear`;
      };

      const setSlide = (nextIndex) => {
        index = nextIndex;
        track.style.transform = `translateX(-${index * 100}%)`;
        tabs.forEach((tab, tabIndex) => {
          tab.classList.toggle('is-active', tabIndex === index);
        });
        startProgress();
      };

      const queue = () => {
        clearTimeout(timerId);
        if (tabs.length <= 1) return;
        timerId = window.setTimeout(() => {
          const nextIndex = (index + 1) % tabs.length;
          setSlide(nextIndex);
          queue();
        }, interval);
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const nextIndex = Number(tab.dataset.index || 0);
          setSlide(nextIndex);
          queue();
        });
      });

      setSlide(0);
      queue();
    };

    const root = document.currentScript?.closest('.shopify-section') || document;
    root.querySelectorAll('[data-home-hero-banner]').forEach(setupHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-review-highlights"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function setupReviewHighlights(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.ready === 'true') return;
      sectionRoot.dataset.ready = 'true';

      const viewport = sectionRoot.querySelector('[data-review-viewport]');
      const track = sectionRoot.querySelector('[data-review-track]');
      const cards = Array.from(sectionRoot.querySelectorAll('.home-review-highlights__card'));
      const prevButton = sectionRoot.querySelector('[data-review-prev]');
      const nextButton = sectionRoot.querySelector('[data-review-next]');
      const desktopVisible = 3;
      let page = 0;
      let touchStartX = 0;
      let touchDeltaX = 0;

      if (!viewport || !track || !cards.length) return;

      const maxPage = () => {
        if (window.innerWidth < 1024) return cards.length - 1;
        return Math.max(0, cards.length - desktopVisible);
      };

      const updateControls = () => {
        if (!prevButton || !nextButton) return;
        prevButton.disabled = page <= 0;
        nextButton.disabled = page >= maxPage();
      };

      const updateSlider = () => {
        const card = cards[0];
        if (!card) return;

        if (window.innerWidth < 1024) {
          const gap = 16;
          const step = card.getBoundingClientRect().width + gap;
          track.style.transform = `translateX(${-page * step}px)`;
        } else {
          const gap = 20;
          const step = card.getBoundingClientRect().width + gap;
          track.style.transform = `translateX(${-page * step}px)`;
        }
        updateControls();
      };

      const clampPage = () => {
        page = Math.max(0, Math.min(page, maxPage()));
      };

      prevButton?.addEventListener('click', () => {
        page -= 1;
        clampPage();
        updateSlider();
      });

      nextButton?.addEventListener('click', () => {
        page += 1;
        clampPage();
        updateSlider();
      });

      viewport.addEventListener(
        'touchstart',
        (event) => {
          if (window.innerWidth >= 1024) return;
          touchStartX = event.touches[0]?.clientX || 0;
          touchDeltaX = 0;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        (event) => {
          if (window.innerWidth >= 1024) return;
          const currentX = event.touches[0]?.clientX || 0;
          touchDeltaX = currentX - touchStartX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        () => {
          if (window.innerWidth >= 1024) return;
          if (Math.abs(touchDeltaX) < 40) return;

          if (touchDeltaX < 0) {
            page += 1;
          } else {
            page -= 1;
          }

          clampPage();
          updateSlider();
          touchStartX = 0;
          touchDeltaX = 0;
        },
        { passive: true }
      );

      sectionRoot.querySelectorAll('[data-review-excerpt]').forEach((excerpt) => {
        const toggle = excerpt.parentElement?.querySelector('[data-review-toggle]');
        if (!toggle) return;
        requestAnimationFrame(() => {
          if (excerpt.scrollHeight > excerpt.clientHeight + 1) {
            toggle.hidden = false;
          }
        });
        toggle.addEventListener('click', () => {
          excerpt.classList.toggle('is-expanded');
          toggle.textContent = excerpt.classList.contains('is-expanded')
            ? 'Show less'
            : 'Read more';
        });
      });

      window.addEventListener('resize', () => {
        clampPage();
        updateSlider();
      });

      updateSlider();
    }

    const init = (root) => {
      root.querySelectorAll('[data-home-review-highlights]').forEach(setupReviewHighlights);
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials-logos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const INTERVAL = 3000;

    function setupTestimonials(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.ready === 'true') return;
      sectionRoot.dataset.ready = 'true';

      const panels = Array.from(sectionRoot.querySelectorAll('[data-testimonial-panel]'));
      const tabs = Array.from(sectionRoot.querySelectorAll('[data-testimonial-tab]'));
      const segments = Array.from(sectionRoot.querySelectorAll('[data-testimonial-dot]'));
      const mobileDots = Array.from(sectionRoot.querySelectorAll('[data-testimonial-mobile-dot]'));
      const track = sectionRoot.querySelector('[data-testimonial-track]');
      if (!panels.length || !tabs.length || !track) return;

      let activeIndex = 0;
      let timer = null;

      const syncTrack = () => {
        const activeTab = tabs[activeIndex];
        if (!activeTab) return;
        const trackRect = track.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();
        const delta = (trackRect.left + trackRect.width / 2) - (tabRect.left + tabRect.width / 2);
        track.style.transform = `translateX(${delta}px)`;
      };

      const activate = (index) => {
        activeIndex = index;
        panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        segments.forEach((segment, segmentIndex) => {
          segment.classList.toggle('is-active', segmentIndex <= index);
        });
        mobileDots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
        syncTrack();
      };

      const schedule = () => {
        clearTimeout(timer);
        timer = window.setTimeout(() => {
          activate((activeIndex + 1) % panels.length);
          schedule();
        }, INTERVAL);
      };

      [...tabs, ...segments, ...mobileDots].forEach((control) => {
        control.addEventListener('click', () => {
          activate(Number(control.dataset.index || 0));
          schedule();
        });
      });

      sectionRoot.addEventListener('mouseenter', () => clearTimeout(timer));
      sectionRoot.addEventListener('mouseleave', schedule);
      window.addEventListener('resize', syncTrack);

      activate(0);
      schedule();
    }

    const init = (root) => {
      root.querySelectorAll('[data-home-testimonials-logos]').forEach(setupTestimonials);
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);

    const initSection = (root) => {
      root.querySelectorAll('.main-product-v2').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const track = section.querySelector('[data-product-track]');
        const mediaNodes = Array.from(section.querySelectorAll('[data-media-id]')).filter((node) => node.classList.contains('main-product-v2__media'));
        const variants = JSON.parse(section.querySelector('[data-product-variants]')?.textContent || '[]');
        const productForm = section.querySelector(`#MainProductForm-${section.id?.replace('shopify-section-', '')}`) || section.querySelector('.main-product-v2__form');
        const variantInput = section.querySelector('[data-variant-id]');
        const optionGroups = Array.from(section.querySelectorAll('[data-option-index]'));
        const priceCurrent = section.querySelector('[data-price-current]');
        const priceCompare = section.querySelector('[data-price-compare]');
        const saleBadge = section.querySelector('[data-sale-badge]');
        const submitButton = section.querySelector('[data-submit-button]');
        const submitText = section.querySelector('[data-submit-text]');
        const stickyPrice = section.querySelector('[data-sticky-price-current]');
        const stickySubmit = section.querySelector('[data-sticky-submit]');
        const galleryPrev = section.querySelector('[data-gallery-prev]');
        const galleryNext = section.querySelector('[data-gallery-next]');
        const galleryThumbsWrap = section.querySelector('[data-gallery-thumbnails]');
        const galleryThumbs = Array.from(section.querySelectorAll('[data-gallery-thumb]'));
        const THUMB_WINDOW_SIZE = 5;
        const THUMB_WINDOW_RADIUS = 2;
        const qtyMinus = section.querySelector('[data-qty-minus]');
        const qtyPlus = section.querySelector('[data-qty-plus]');
        const qtyInput = section.querySelector('.quantity__input');
        const stickyQtyMinus = section.querySelector('[data-sticky-qty-minus]');
        const stickyQtyPlus = section.querySelector('[data-sticky-qty-plus]');
        const stickyQtyValue = section.querySelector('[data-sticky-qty-value]');
        const accessoryRoot = section.querySelector('[data-linked-products-root]');
        const accessoryCheckboxes = Array.from(accessoryRoot?.querySelectorAll('[data-linked-product-checkbox]') || []);
        const stickyDropdown = section.querySelector('[data-sticky-dropdown]');
        const stickyOptionToggle = section.querySelector('[data-sticky-option-toggle]');
        const stickyOptionSelected = section.querySelector('[data-sticky-option-selected]');
        const stickyOptionItems = Array.from(section.querySelectorAll('[data-sticky-option-item]'));
        const stickyForm = section.querySelector('.sticky-form');
        const addToCartLabel = section.dataset.addToCartLabel || 'Add to cart';
        let activeMediaIndex = Math.max(0, mediaNodes.findIndex((node) => node.classList.contains('is-active')));

        const notifyCart = (message) => {
          document.dispatchEvent(new CustomEvent('cart:notify', { detail: { message } }));
        };

        const updateAccessorySelectionState = () => {
          accessoryCheckboxes.forEach((checkbox) => {
            checkbox.closest('[data-linked-product-card]')?.classList.toggle('is-selected', checkbox.checked);
          });
        };

        const getSelectedAccessoryItems = () => {
          return accessoryCheckboxes
            .filter((checkbox) => checkbox.checked && checkbox.value)
            .map((checkbox) => ({
              id: Number(checkbox.value),
              quantity: 1
            }))
            .filter((item) => Number.isFinite(item.id) && item.id > 0);
        };

        const submitAddToCart = async () => {
          if (!productForm || !variantInput || !variantInput.value) return;
          const selectedVariantId = Number(variantInput.value);
          const matchedVariant = variants.find((variant) => Number(variant.id) === selectedVariantId);
          const requestedQty = Math.max(1, Number(qtyInput?.value || 1));
          const accessoryItems = getSelectedAccessoryItems();
          const currentCart = window.JUICED_CART_STATE;
          const mainItemAlreadyInCart =
            currentCart &&
            Array.isArray(currentCart.items) &&
            currentCart.items.find((item) => Number(item.variant_id) === selectedVariantId);

          if (
            !mainItemAlreadyInCart &&
            matchedVariant &&
            matchedVariant.inventory_management &&
            matchedVariant.inventory_policy !== 'continue' &&
            typeof matchedVariant.inventory_quantity === 'number' &&
            requestedQty > matchedVariant.inventory_quantity
          ) {
            notifyCart(`Only ${matchedVariant.inventory_quantity} left in stock`);
            return;
          }
          if (mainItemAlreadyInCart && accessoryItems.length === 0) {
            document.dispatchEvent(new CustomEvent('cart:open'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            notifyCart('This item is already in your cart');
            return;
          }

          const itemsToAdd = [];
          if (!mainItemAlreadyInCart) {
            itemsToAdd.push({
              id: selectedVariantId,
              quantity: requestedQty
            });
          }
          itemsToAdd.push(...accessoryItems);

          if (!itemsToAdd.length) return;

          const submitLabel = submitText?.textContent || addToCartLabel;
          if (submitButton) submitButton.disabled = true;
          if (stickySubmit) stickySubmit.disabled = true;
          if (submitText) submitText.textContent = 'Adding...';
          if (stickySubmit) stickySubmit.textContent = 'Adding...';

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items: itemsToAdd }),
              credentials: 'same-origin'
            });

            if (!response.ok) {
              const errorData = await response.json().catch(() => null);
              notifyCart(errorData?.description || 'Unable to add this item');
              throw new Error(errorData?.description || 'Add to cart failed');
            }

            await response.json();
            accessoryCheckboxes.forEach((checkbox) => {
              checkbox.checked = false;
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            });
            document.dispatchEvent(new CustomEvent('cart:open'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            notifyCart(accessoryItems.length > 0 ? 'Products added to cart' : 'Product added to cart');
          } catch (error) {
            console.error(error);
          } finally {
            updateVariant();
            if (submitText && submitText.textContent === 'Adding...') {
              submitText.textContent = submitLabel;
            }
          }
        };

        const syncMediaPlayback = () => {
          mediaNodes.forEach((node, mediaIndex) => {
            const videos = Array.from(node.querySelectorAll('video'));
            const isActive = mediaIndex === activeMediaIndex;

            videos.forEach((video) => {
              if (isActive) {
                video.muted = true;
                video.loop = true;
                video.playsInline = true;
                const playAttempt = video.play();
                if (playAttempt && typeof playAttempt.catch === 'function') {
                  playAttempt.catch(() => {});
                }
              } else {
                video.pause();
                video.currentTime = 0;
              }
            });
          });
        };

        const updateThumbnailWindow = () => {
          const totalThumbs = galleryThumbs.length;
          let windowStart = activeMediaIndex - THUMB_WINDOW_RADIUS;
          let windowEnd = activeMediaIndex + THUMB_WINDOW_RADIUS;

          if (totalThumbs > THUMB_WINDOW_SIZE) {
            if (windowStart < 0) {
              windowStart = 0;
              windowEnd = THUMB_WINDOW_SIZE - 1;
            }

            if (windowEnd > totalThumbs - 1) {
              windowEnd = totalThumbs - 1;
              windowStart = totalThumbs - THUMB_WINDOW_SIZE;
            }
          } else {
            windowStart = 0;
            windowEnd = totalThumbs - 1;
          }

          galleryThumbs.forEach((thumb, thumbIndex) => {
            const inWindow = thumbIndex >= windowStart && thumbIndex <= windowEnd;
            thumb.hidden = !inWindow;
            thumb.setAttribute('aria-hidden', inWindow ? 'false' : 'true');
            thumb.tabIndex = inWindow ? 0 : -1;
          });
        };

        const updateGalleryControls = () => {
          if (galleryPrev) galleryPrev.disabled = activeMediaIndex <= 0;
          if (galleryNext) galleryNext.disabled = activeMediaIndex >= mediaNodes.length - 1;
          updateThumbnailWindow();
          if (galleryThumbsWrap) {
            galleryThumbsWrap.dataset.activeIndex = String(activeMediaIndex);
          }
          if (track) {
            track.style.transform = `translateX(-${activeMediaIndex * 100}%)`;
          }
        };

        const setActiveMediaByIndex = (index) => {
          if (!mediaNodes.length) return;
          const nextIndex = Math.max(0, Math.min(index, mediaNodes.length - 1));
          if (nextIndex === activeMediaIndex) {
            updateGalleryControls();
            syncMediaPlayback();
            return;
          }

          activeMediaIndex = nextIndex;
          mediaNodes.forEach((node, mediaIndex) => {
            node.classList.remove('is-entering-from-right', 'is-entering-from-left', 'is-leaving-to-left', 'is-leaving-to-right');
            node.classList.toggle('is-active', mediaIndex === activeMediaIndex);
          });
          galleryThumbs.forEach((thumb, thumbIndex) => {
            const isActive = thumbIndex === activeMediaIndex;
            thumb.classList.toggle('is-active', isActive);
            if (isActive) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
          updateGalleryControls();
          syncMediaPlayback();
        };

        const setActiveMediaById = (mediaId) => {
          const nextIndex = mediaNodes.findIndex((node) => String(node.dataset.mediaId) === String(mediaId));
          if (nextIndex >= 0) setActiveMediaByIndex(nextIndex);
        };

        const getSelectedOptions = () => optionGroups.map((group) => group.querySelector('input:checked')?.value || '');

        const syncStickyQty = () => {
          if (!qtyInput || !stickyQtyValue) return;
          stickyQtyValue.textContent = String(Math.max(1, Number(qtyInput.value || 1)));
        };

        const closeStickyDropdown = () => {
          if (!stickyDropdown || !stickyOptionToggle) return;
          stickyDropdown.classList.remove('is-open');
          stickyOptionToggle.setAttribute('aria-expanded', 'false');
        };

        const updateStickyColorOptions = () => {
          if (!stickyOptionItems.length) return;
          const colorIndex = Number(stickyOptionItems[0]?.dataset.stickyOptionIndex);
          if (Number.isNaN(colorIndex)) return;

          const selected = getSelectedOptions();

          stickyOptionItems.forEach((item) => {
            const candidate = selected.slice();
            candidate[colorIndex] = item.dataset.stickyOptionValue;
            const matched = variants.find((variant) => candidate.every((value, index) => variant.options[index] === value));
            const disabled = !matched || !matched.available;
            const baseLabel = item.dataset.stickyOptionLabel || item.dataset.stickyOptionValue || '';
            item.disabled = disabled;
            item.setAttribute('aria-disabled', disabled ? 'true' : 'false');
            item.textContent = disabled ? `${baseLabel} - Sold out` : baseLabel;
          });
        };

        const updateVariant = () => {
          const selected = getSelectedOptions();
          const matched = variants.find((variant) => selected.every((value, index) => variant.options[index] === value));
          if (!matched) return;

          if (variantInput) variantInput.value = matched.id;
          if (priceCurrent) priceCurrent.textContent = money(matched.price);
          if (stickyPrice) stickyPrice.textContent = money(matched.price);

          if (priceCompare) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              priceCompare.textContent = money(matched.compare_at_price);
              priceCompare.classList.remove('is-hidden');
            } else {
              priceCompare.classList.add('is-hidden');
              priceCompare.textContent = '';
            }
          }

          if (saleBadge) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              const percent = Math.round(((matched.compare_at_price - matched.price) / matched.compare_at_price) * 100);
              saleBadge.textContent = `Save ${percent}%`;
              saleBadge.classList.remove('is-hidden');
            } else {
              saleBadge.classList.add('is-hidden');
              saleBadge.textContent = '';
            }
          }

          if (submitButton && submitText) {
            submitButton.disabled = !matched.available;
            submitText.textContent = matched.available ? addToCartLabel : 'Sold out';
          }

          if (stickySubmit) {
            stickySubmit.disabled = !matched.available;
            stickySubmit.textContent = matched.available ? addToCartLabel : 'Sold out';
          }

          const colorGroup = optionGroups.find((group) => group.dataset.optionType === 'color');
          if (stickyOptionSelected && colorGroup) {
            const checked = colorGroup.querySelector('input:checked');
            if (checked) {
              stickyOptionSelected.textContent = checked.value;
              stickyOptionItems.forEach((item) => {
                const isActive = item.dataset.stickyOptionValue === checked.value;
                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
              });
            }
          }

          updateStickyColorOptions();

          if (matched.featured_media?.id) {
            setActiveMediaById(matched.featured_media.id);
          }
        };

        optionGroups.forEach((group) => {
          group.addEventListener('change', () => {
            group.querySelectorAll('.label-swatch').forEach((label) => label.classList.remove('is-active'));
            const checked = group.querySelector('input:checked');
            if (checked) {
              checked.closest('.label-swatch')?.classList.add('is-active');
              const selectedText = group.querySelector('[data-option-selected]');
              if (selectedText) selectedText.textContent = checked.value;
            }
            updateVariant();
          });
        });

        stickyOptionToggle?.addEventListener('click', () => {
          if (!stickyDropdown) return;
          const open = !stickyDropdown.classList.contains('is-open');
          stickyDropdown.classList.toggle('is-open', open);
          stickyOptionToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        stickyOptionItems.forEach((item) => {
          item.addEventListener('click', () => {
            if (item.disabled) return;
            const colorGroup = optionGroups.find((group) => group.dataset.optionType === 'color');
            if (!colorGroup) return;
            const targetInput = Array.from(colorGroup.querySelectorAll('input')).find((input) => input.value === item.dataset.stickyOptionValue);
            if (!targetInput) return;
            targetInput.checked = true;
            targetInput.dispatchEvent(new Event('change', { bubbles: true }));
            closeStickyDropdown();
          });
        });

        document.addEventListener('click', (event) => {
          if (!stickyDropdown) return;
          if (stickyDropdown.contains(event.target)) return;
          closeStickyDropdown();
        });

        galleryPrev?.addEventListener('click', () => {
          if (activeMediaIndex <= 0) return;
          setActiveMediaByIndex(activeMediaIndex - 1);
        });
        galleryNext?.addEventListener('click', () => {
          if (activeMediaIndex >= mediaNodes.length - 1) return;
          setActiveMediaByIndex(activeMediaIndex + 1);
        });
        galleryThumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => setActiveMediaById(thumb.dataset.mediaId));
        });

        qtyMinus?.addEventListener('click', () => {
          if (!qtyInput) return;
          qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
          syncStickyQty();
        });

        qtyPlus?.addEventListener('click', () => {
          if (!qtyInput) return;
          qtyInput.value = String(Number(qtyInput.value || 1) + 1);
          syncStickyQty();
        });

        stickyQtyMinus?.addEventListener('click', () => {
          if (!qtyInput) return;
          qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
          syncStickyQty();
        });

        stickyQtyPlus?.addEventListener('click', () => {
          if (!qtyInput) return;
          qtyInput.value = String(Number(qtyInput.value || 1) + 1);
          syncStickyQty();
        });

        qtyInput?.addEventListener('input', syncStickyQty);

        accessoryCheckboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', updateAccessorySelectionState);
        });

        accessoryRoot?.querySelectorAll('[data-linked-product-card]').forEach((card) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a, button, input')) return;

            const checkbox = card.querySelector('[data-linked-product-checkbox]');
            if (!checkbox || checkbox.disabled) return;

            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        productForm?.addEventListener('submit', (event) => {
          event.preventDefault();
          submitAddToCart();
        });

        stickySubmit?.addEventListener('click', () => {
          submitAddToCart();
        });

        const stickyTrigger = section.querySelector('.main-product-v2__purchase-card') || productForm || section;
        const toggleSticky = () => {
          if (!stickyForm) return;
          const triggerRect = stickyTrigger.getBoundingClientRect();
          const shouldShowSticky = triggerRect.bottom <= Math.min(window.innerHeight * 0.35, 260);
          stickyForm.classList.toggle('is-visible', shouldShowSticky);
        };

        window.addEventListener('scroll', toggleSticky, { passive: true });
        window.addEventListener('resize', toggleSticky);
        toggleSticky();
        updateAccessorySelectionState();

        section.querySelectorAll('[data-countdown-root]').forEach((countdown) => {
          const end = new Date(countdown.dataset.countdownEnd || '').getTime();
          if (!end) return;
          const daysNode = countdown.querySelector('[data-countdown-days]');
          const hoursNode = countdown.querySelector('[data-countdown-hours]');
          const minutesNode = countdown.querySelector('[data-countdown-minutes]');
          const secondsNode = countdown.querySelector('[data-countdown-seconds]');

          const tick = () => {
            const diff = Math.max(0, end - Date.now());
            const days = Math.floor(diff / 86400000);
            const hours = Math.floor((diff % 86400000) / 3600000);
            const minutes = Math.floor((diff % 3600000) / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);
            if (daysNode) daysNode.textContent = String(days).padStart(2, '0');
            if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
            if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
            if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
          };

          tick();
          window.setInterval(tick, 1000);
        });

        updateVariant();
        updateGalleryControls();
        syncStickyQty();
      });
    };

    initSection(document);
    document.addEventListener('shopify:section:load', (event) => initSection(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTabs = (scope) => {
      const sections = scope.querySelectorAll('.product-information-tabs');

      sections.forEach((section) => {
        if (section.dataset.tabsReady === 'true') return;
        section.dataset.tabsReady = 'true';

        const triggers = Array.from(section.querySelectorAll('[data-tab-trigger]'));
        const panels = Array.from(section.querySelectorAll('[data-tab-panel]'));
        if (!triggers.length || !panels.length) return;

        const activateTab = (name) => {
          triggers.forEach((trigger) => {
            const isActive = trigger.dataset.tabTrigger === name;
            trigger.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.dataset.tabPanel === name;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        };

        triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => activateTab(trigger.dataset.tabTrigger));
        });
      });
    };

    initTabs(document);

    document.addEventListener('shopify:section:load', (event) => {
      initTabs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-installments-app"]) return;
  try {
    
  (() => {
    const forceUsKlarnaPlacement = (placement) => {
      if (!placement || typeof placement !== 'object') return placement;

      placement.storefrontCountry = 'US';
      placement.storefrontCurrency = placement.storefrontCurrency || 'USD';
      placement.storefrontLanguage = 'en';
      placement.shopLocale = 'en-US';
      placement.locale = 'en-US';
      placement.fallbackLocale = 'en-US';

      return placement;
    };

    const patchKlarnaQueues = () => {
      if (Array.isArray(window.appBlockPlacements)) {
        window.appBlockPlacements.forEach(forceUsKlarnaPlacement);
      }

      if (Array.isArray(window.klarnaAppBlocksManager)) {
        window.klarnaAppBlocksManager.forEach(forceUsKlarnaPlacement);
      }

      if (Array.isArray(window.klarnaAppBlocksManager?.placements)) {
        window.klarnaAppBlocksManager.placements.forEach(forceUsKlarnaPlacement);
      }
    };

    const patchKlarnaPush = (host) => {
      if (!host || host.__forcedUsPatchApplied) return;
      if (typeof host.push !== 'function') return;

      const originalPush = host.push.bind(host);

      host.push = (...items) => {
        const patchedItems = items.map(forceUsKlarnaPlacement);
        return originalPush(...patchedItems);
      };

      host.__forcedUsPatchApplied = true;
    };

    const patchKlarnaElements = (root = document) => {
      root.querySelectorAll('klarna-placement').forEach((node) => {
        node.setAttribute('data-purchase-country', 'US');
        node.setAttribute('data-locale', 'en-US');
        node.setAttribute('data-region', 'US');
      });
    };

    const hasContent = (node) => {
      if (!node) return false;
      if (node.children.length > 0) return true;
      return node.textContent.replace(/\s+/g, '').length > 0;
    };

    const syncInstallments = () => {
      const sources = document.querySelectorAll('[data-product-installments-source]');

      sources.forEach((source) => {
        const productId = source.dataset.productInstallmentsSource;
        const sourceContent = source.querySelector('[data-product-installments-source-content]');
        const target = document.querySelector(`[data-main-product-installments-target="${productId}"]`);
        const container = document.querySelector(`[data-main-product-installments-container="${productId}"]`);
        const fallback = container?.querySelector('[data-main-product-installments-fallback]');

        if (!sourceContent || !target || !container) return;

        patchKlarnaElements(sourceContent);

        if (sourceContent.childNodes.length > 0) {
          target.replaceChildren(...Array.from(sourceContent.childNodes));
        }

        patchKlarnaElements(target);

        const shouldShowAppContent = hasContent(target);
        container.hidden = !shouldShowAppContent && !fallback;

        if (fallback) {
          fallback.hidden = shouldShowAppContent;
        }
      });
    };

    const observeInstallments = () => {
      const sources = document.querySelectorAll('[data-product-installments-source]');

      sources.forEach((source) => {
        if (source.dataset.productInstallmentsObserved === 'true') return;

        const sourceContent = source.querySelector('[data-product-installments-source-content]');
        if (!sourceContent) return;

        const observer = new MutationObserver(() => {
          syncInstallments();
        });

        observer.observe(sourceContent, {
          childList: true,
          subtree: true,
          characterData: true
        });

        source.dataset.productInstallmentsObserved = 'true';
      });
    };

    const reinforceKlarnaUsContext = () => {
      patchKlarnaPush(window.appBlockPlacements);
      patchKlarnaPush(window.klarnaAppBlocksManager);
      patchKlarnaQueues();
      patchKlarnaElements();
    };

    const initInstallments = () => {
      reinforceKlarnaUsContext();
      observeInstallments();
      syncInstallments();
      window.setTimeout(reinforceKlarnaUsContext, 100);
      window.setTimeout(reinforceKlarnaUsContext, 500);
      window.setTimeout(reinforceKlarnaUsContext, 1500);
      window.setTimeout(syncInstallments, 300);
      window.setTimeout(syncInstallments, 1000);
      window.setTimeout(syncInstallments, 2000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initInstallments, { once: true });
    } else {
      initInstallments();
    }

    document.addEventListener('shopify:section:load', initInstallments);
    document.addEventListener('shopify:block:select', initInstallments);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-linked-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLinkedProducts = (scope) => {
      scope.querySelectorAll('[data-linked-products-root]').forEach((rootEl) => {
        if (rootEl.dataset.ready === 'true') return;
        rootEl.dataset.ready = 'true';

        const updateState = () => {
          const checkboxes = Array.from(rootEl.querySelectorAll('[data-linked-product-checkbox]'));

          checkboxes.forEach((checkbox) => {
            checkbox.closest('.product-linked-products-section__card--selectable')?.classList.toggle('is-selected', checkbox.checked);
          });
        };

        const checkboxes = Array.from(rootEl.querySelectorAll('[data-linked-product-checkbox]'));

        checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', updateState);
        });

        rootEl.querySelectorAll('[data-linked-product-card]').forEach((card) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a, button, input')) return;

            const checkbox = card.querySelector('[data-linked-product-checkbox]');
            if (!checkbox || checkbox.disabled) return;

            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        updateState();
      });
    };

    initLinkedProducts(document);

    document.addEventListener('shopify:section:load', (event) => {
      initLinkedProducts(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const manualPrev = event.target.closest('[data-related-carousel-prev]');
    const manualNext = event.target.closest('[data-related-carousel-next]');

    if (manualPrev || manualNext) {
      const scope = (manualPrev || manualNext).closest('.product-recommendations-custom');
      if (!scope) return;

      const nativeTrigger = manualPrev
        ? scope.querySelector('xo-carousel-prev.carousel-navigation-style1__arrow button')
        : scope.querySelector('xo-carousel-next.carousel-navigation-style1__arrow button');

      nativeTrigger?.click();
      return;
    }

    const swatch = event.target.closest('[data-recommendation-swatch]');
    if (!swatch) return;

    const card = swatch.closest('[data-recommendation-card]');
    if (!card) return;

    const targetHandle = swatch.getAttribute('data-recommendation-swatch');
    if (!targetHandle) return;

    const swatches = card.querySelectorAll('[data-recommendation-swatch]');
    const images = card.querySelectorAll('[data-recommendation-image]');

    swatches.forEach(function (item) {
      const isActive = item === swatch;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    images.forEach(function (image) {
      image.classList.toggle('is-active', image.getAttribute('data-recommendation-image') === targetHandle);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initProductSections = (root) => {
      root.querySelectorAll('.product-main').forEach((section) => {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        const variantsScript = section.querySelector('[data-product-variants]');
        if (!variantsScript) return;

        const variants = JSON.parse(variantsScript.textContent || '[]');
        const form = section.querySelector('.product-main__form');
        const variantIdInput = section.querySelector('[data-variant-id-input]');
        const priceNode = section.querySelector('[data-product-price]');
        const compareNode = section.querySelector('[data-product-compare-price]');
        const submitButton = section.querySelector('[data-product-submit]');
        const submitText = section.querySelector('[data-product-submit-text]');
        const optionGroups = Array.from(section.querySelectorAll('[data-option-index]'));
        const mediaNodes = Array.from(section.querySelectorAll('[data-product-media]'));
        const thumbNodes = Array.from(section.querySelectorAll('[data-product-thumb]'));
        const quantityRoot = section.querySelector('[data-quantity-root]');

        const moneyFormat = (cents) => {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
        };

        const getSelectedOptions = () => {
          return optionGroups.map((group) => {
            const checked = group.querySelector('input[type="radio"]:checked');
            return checked ? checked.value : '';
          });
        };

        const syncOptionLabels = () => {
          optionGroups.forEach((group) => {
            const selected = group.querySelector('input[type="radio"]:checked');
            const label = group.querySelector('[data-option-selected]');
            const labels = group.querySelectorAll('[data-option-label]');
            labels.forEach((item) => item.classList.remove('is-active'));
            if (selected) {
              const active = selected.closest('[data-option-label]');
              if (active) active.classList.add('is-active');
              if (label) label.textContent = selected.value;
            }
          });
        };

        const syncMedia = (variant) => {
          if (!variant || !variant.featured_media) return;
          const mediaId = String(variant.featured_media.id);
          mediaNodes.forEach((node) => node.classList.toggle('is-active', node.dataset.mediaId === mediaId));
          thumbNodes.forEach((node) => node.classList.toggle('is-active', node.dataset.mediaId === mediaId));
        };

        const syncVariant = () => {
          const selectedOptions = getSelectedOptions();
          const matched = variants.find((variant) => {
            return selectedOptions.every((value, index) => variant.options[index] === value);
          });

          if (!matched) return;

          if (variantIdInput) variantIdInput.value = matched.id;
          if (priceNode) priceNode.textContent = moneyFormat(matched.price);

          if (compareNode) {
            if (matched.compare_at_price && matched.compare_at_price > matched.price) {
              compareNode.textContent = moneyFormat(matched.compare_at_price);
              compareNode.classList.remove('is-hidden');
            } else {
              compareNode.textContent = '';
              compareNode.classList.add('is-hidden');
            }
          }

          if (submitButton && submitText) {
            submitButton.disabled = !matched.available;
            submitText.textContent = matched.available ? 'Add to cart' : 'Sold out';
          }

          syncMedia(matched);

          const url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
        };

        thumbNodes.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const mediaId = thumb.dataset.mediaId;
            mediaNodes.forEach((node) => node.classList.toggle('is-active', node.dataset.mediaId === mediaId));
            thumbNodes.forEach((node) => node.classList.toggle('is-active', node.dataset.mediaId === mediaId));
          });
        });

        optionGroups.forEach((group) => {
          group.addEventListener('change', () => {
            syncOptionLabels();
            syncVariant();
          });
        });

        if (quantityRoot) {
          const input = quantityRoot.querySelector('.product-main__quantity-input');
          const minus = quantityRoot.querySelector('[data-quantity-minus]');
          const plus = quantityRoot.querySelector('[data-quantity-plus]');

          if (input && minus && plus) {
            minus.addEventListener('click', () => {
              const current = Number(input.value || 1);
              input.value = String(Math.max(1, current - 1));
            });

            plus.addEventListener('click', () => {
              const current = Number(input.value || 1);
              input.value = String(current + 1);
            });
          }
        }

        syncOptionLabels();
        syncVariant();
      });
    };

    initProductSections(document);
    document.addEventListener('shopify:section:load', (event) => initProductSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
